import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { apiUrl } from '@/utils/config';
import { VERSION } from "@/utils/vuever";

// 这里写的是axios请求的时候的配置
let baseUrl = apiUrl;
let _axios = axios.create({
    baseURL: baseUrl,
    timeout: '3000',
    withCredentials: true, // 设置默认请求带cookie
    crossDomain: true
});
// 请求拦截器
_axios.interceptors.request.use(
    config => {
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                t: new Date().getTime(),
                vue_ver: VERSION
            };
        }
        config.params.VUE_TYPE = "invite";
        return config;
    },

);
// 响应拦截器
_axios.interceptors.response.use(
    response => {
        return Promise.resolve(response);
    },
    error => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        console.log(error);

        if (error.response.status == 303) {
            let url = window.location.href;
            let version = new Date().getTime();
            if (url.indexOf('?', 0) > -1) {
                location.replace(url + '&vue_ver=' + version);
            } else {
                location.replace(url + '?vue_ver=' + version);
            }
            return Promise.reject(error);
        }
    }
)

Vue.use(VueAxios, _axios)

// 邀请官网
_axios.inviteHome = (params) => {
    return Vue.axios.get('/other/inviteHome', {
        params: params,
        keep_cache: 0,
    })
}

// 下载地址
_axios.inviteUrl = () => {
    return Vue.axios.get('/other/install')
}

// 口令获取接口
_axios.passCodeCreate = () => {
    return Vue.axios.get('web/passCodeCreate')
}
